import React from 'react';
var backgroundColor_gray = "#f5f5f5";
var backgroundColor_white = "#ffffff";

function skeltonScreenForMyAccountOverview() {
    return (
        <div style={{ margin: "auto", paddingTop: "0px", position: "relative" }} className="animated fadeIn px-5">
            <div className="px-5">
            <div className="skeltonScreenAnimatedOverlay_white"></div>
            <div className="row" style={{ marginTop: '60px' }}>
                <div className="col-md-7">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "250px", width: "97%", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
                    </div>
                </div>
                <div className="col-md-5">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "250px", backgroundColor: backgroundColor_gray, marginRight: '15px' }}></div>
                    </div>
                </div>
            </div>
            <div style={{ paddingBottom: "10px", paddingTop: "40px" }}>
                <div style={{ borderRadius: "4px", height: "25px", width: "15%", backgroundColor: backgroundColor_gray, marginLeft: '15px' }}></div>
            </div>
            <div className="d-flex" style={{ paddingBottom: "50px", marginLeft: '15px', marginRight: '15px' }}>
                <div className=" mr-5" style={{ width:'22%',borderRadius: "4px", height: "188px", backgroundColor: backgroundColor_gray }}></div>
                <div className="mr-5" style={{  width:'22%',borderRadius: "4px", height: "188px", backgroundColor: backgroundColor_gray }}></div>
                <div className=" mr-5" style={{ width:'22%', borderRadius: "4px", height: "188px", backgroundColor: backgroundColor_gray }}></div>
                <div className="" style={{ width:'21%', borderRadius: "4px", height: "188px", backgroundColor: backgroundColor_gray }}></div>
            </div>
            </div>
        </div>
    );
}

function skeltonScreenForMyAccountSub() {
    return (
        <div style={{ margin: "auto", paddingTop: "0px", position: "relative" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_white"></div>
            <div className="row" style={{ marginTop: '60px' }}>
                <div className="col-md-7">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "250px", width: "97%", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
                    </div>
                </div>
                <div className="col-md-5">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "250px", backgroundColor: backgroundColor_gray, marginRight: '15px' }}></div>
                    </div>
                </div>
            </div>
            <div style={{ paddingBottom: "10px", paddingTop: "40px" }}>
                <div style={{ borderRadius: "4px", height: "25px", width: "15%", backgroundColor: backgroundColor_gray, marginLeft: '15px' }}></div>
            </div>
            <div className="d-flex" style={{ paddingBottom: "50px", marginLeft: '15px', marginRight: '15px' }}>
                <div className=" mr-5" style={{ width:'32%',borderRadius: "4px", height: "188px", backgroundColor: backgroundColor_gray }}></div>
                <div className="mr-5" style={{  width:'32%',borderRadius: "4px", height: "188px", backgroundColor: backgroundColor_gray }}></div>
                <div className="" style={{ width:'32%', borderRadius: "4px", height: "188px", backgroundColor: backgroundColor_gray }}></div>
            </div>
        </div>
    );
}

function skeltonScreenForMyAccountAddServiceAddress() {
    return (
        <div style={{ margin: "auto", paddingTop: "0px", position: "relative" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_white"></div>
            <div className="row" style={{ marginTop: '60px' }}>
                <div className="col-md-12">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "250px", width: "97%", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function skeltonScreenForMyAccountAddServiceServices() {
    return (
        <div style={{ margin: "auto", paddingTop: "0px", position: "relative" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_white"></div>
            <div className="row" style={{ marginTop: '60px' ,marginBottom:60}}>
                <div className="col-md-8">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "350px", width: "97%", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "350px", backgroundColor: backgroundColor_gray, marginRight: '15px' }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function skeltonScreenForBillingAndPayments() {
    return (
        <div style={{ width: "85%", margin: "auto", paddingTop: "60px", position: "relative", marginTop: "-10%" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_white"></div>
            <div style={{ paddingBottom: "20px", marginTop: '-1%' }}>
                <div style={{ borderRadius: "4px", height: "25px", width: "28%", backgroundColor: backgroundColor_gray, marginLeft: '15px' }}></div>
            </div>
            <div style={{ paddingBottom: "30px" }}>
                <div style={{ borderRadius: "4px", height: "300px", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
            </div>
        </div>
    );
}

function skeltonScreenForManagePlan() {
    return (
        <div style={{ width: "80%", margin: "auto", paddingTop: "60px", position: "relative" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_white"></div>
            <div className="row mt-3">
                <div className="col-md-8">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "25px", width: "38%", backgroundColor: backgroundColor_gray, marginLeft: '15px' }}></div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "25px", width: "65%", backgroundColor: backgroundColor_gray }}></div>
                    </div>
                </div>
            </div>
            <div style={{ paddingBottom: "5px" }}>
                <div style={{ borderRadius: "4px", height: "20px", width: "46%", backgroundColor: backgroundColor_gray, marginLeft: '15px' }}></div>
            </div>
            <div className="row">
                <div className="col-md-8">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "25px", width: "17%", backgroundColor: backgroundColor_gray, marginLeft: '15px' }}></div>
                    </div>
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "200px", width: "97%", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "25px", width: "30%", backgroundColor: backgroundColor_gray }}></div>
                    </div>
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "200px", backgroundColor: backgroundColor_gray, marginRight: '15px' }}></div>
                    </div>
                </div>
            </div>

            <div style={{ paddingTop: "30px" }}>
                <div style={{ borderRadius: "4px", height: "180px", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
            </div>

            <div style={{ paddingBottom: "10px", paddingTop: "40px" }}>
                <div style={{ borderRadius: "4px", height: "25px", width: "17%", backgroundColor: backgroundColor_gray, marginLeft: '15px' }}></div>
            </div>
            <div style={{ paddingBottom: "5px" }}>
                <div style={{ borderRadius: "4px", height: "60px", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
            </div>

            <div style={{ paddingBottom: "10px", paddingTop: "40px" }}>
                <div style={{ borderRadius: "4px", height: "20px", width: "8%", backgroundColor: backgroundColor_gray, marginLeft: '15px' }}></div>
            </div>
            <div style={{ paddingBottom: "5px" }}>
                <div style={{ borderRadius: "4px", height: "60px", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
            </div>
            <div style={{ paddingBottom: "5px" }}>
                <div style={{ borderRadius: "4px", height: "60px", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
            </div>

            <div style={{ paddingBottom: "10px", paddingTop: "40px" }}>
                <div style={{ borderRadius: "4px", height: "25px", width: "22%", backgroundColor: backgroundColor_gray, marginLeft: '15px' }}></div>
            </div>
            <div style={{ paddingBottom: "5px" }}>
                <div style={{ borderRadius: "4px", height: "60px", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
            </div>

            <div style={{ paddingBottom: "10px", paddingTop: "40px" }}>
                <div style={{ borderRadius: "4px", height: "25px", width: "19%", backgroundColor: backgroundColor_gray, marginLeft: '15px' }}></div>
            </div>
            <div style={{ paddingBottom: "5px" }}>
                <div style={{ borderRadius: "4px", height: "60px", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
            </div>
        </div>
    );
}

function skeltonScreenForSettings() {
    return (
        <div style={{  marginRight:'auto',marginLeft: "auto", marginTop: "-10%", width:'85%', position: "relative" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_white"></div>
            <div className="row" style={{ marginTop: '60px' }}>
                <div className="col-md-6">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "180px", width: "97%", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "180px", backgroundColor: backgroundColor_gray, marginRight: '15px' }}></div>
                    </div>
                </div>
            </div>
            <div className="row" style={{ marginTop: '20px' }}>
                <div className="col-md-6">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "250px", width: "97%", backgroundColor: backgroundColor_gray, marginLeft: '15px', marginRight: '15px' }}></div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "250px", backgroundColor: backgroundColor_gray, marginRight: '15px' }}></div>
                    </div>
                </div>
            </div>
        
        </div>
    );
}

function skeltonScreenForServiceCenter() {
    return (
        <div style={{ width: "80%", margin: "auto", paddingTop: "40px", position: "relative" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_white"></div>
            <div style={{ paddingBottom: "5px" }}>
                <div style={{ borderRadius: "4px", height: "50px", backgroundColor: backgroundColor_gray }}></div>
            </div>
            <div style={{ paddingBottom: "15px", paddingTop: "25px" }}>
                <div style={{ borderRadius: "4px", height: "25px", width: "53%", backgroundColor: backgroundColor_gray }}></div>
            </div>
            <div style={{ paddingBottom: "2px" }}>
                <div style={{ borderRadius: "4px", height: "50px", backgroundColor: backgroundColor_gray }}></div>
            </div>
            <div style={{ paddingBottom: "2px" }}>
                <div style={{ borderRadius: "4px", height: "50px", backgroundColor: backgroundColor_gray }}></div>
            </div>
            <div style={{ paddingBottom: "2px" }}>
                <div style={{ borderRadius: "4px", height: "50px", backgroundColor: backgroundColor_gray }}></div>
            </div>

            <div style={{ paddingBottom: "15px", paddingTop: "30px" }}>
                <div style={{ borderRadius: "4px", height: "25px", width: "30%", backgroundColor: backgroundColor_gray }}></div>
            </div>
            <div style={{ paddingBottom: "2px" }}>
                <div style={{ borderRadius: "4px", height: "60px", backgroundColor: backgroundColor_gray }}></div>
            </div>
            <div style={{ paddingBottom: "5px" }}>
                <div style={{ borderRadius: "4px", height: "50px", backgroundColor: backgroundColor_gray }}></div>
            </div>

            <div style={{ paddingBottom: "10px", paddingTop: "40px", display: 'flex', justifyContent: 'space-between' }}>
                <div style={{ borderRadius: "4px", height: "25px", width: "35%", backgroundColor: backgroundColor_gray }}></div>
                <div style={{ borderRadius: "4px", height: "25px", width: "18%", backgroundColor: backgroundColor_gray }}></div>
            </div>
            <div style={{ paddingBottom: "5px" }}>
                <div style={{ borderRadius: "4px", height: "50px", backgroundColor: backgroundColor_gray }}></div>
            </div>
            <div style={{ paddingBottom: "2px" }}>
                <div style={{ borderRadius: "4px", height: "60px", backgroundColor: backgroundColor_gray }}></div>
            </div>
            <div style={{ paddingBottom: "2px" }}>
                <div style={{ borderRadius: "4px", height: "60px", backgroundColor: backgroundColor_gray }}></div>
            </div>
            <div style={{ paddingBottom: "2px" }}>
                <div style={{ borderRadius: "4px", height: "60px", backgroundColor: backgroundColor_gray }}></div>
            </div>

        </div>
    );
}

function skeltonScreenForRegisterServices() {
    return (
        <div style={{ width: "100%", margin: "auto", paddingTop: "40px", paddingLeft: "20px", position: "relative" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_gray"></div>
            <div style={{ paddingBottom: "10px" ,paddingLeft:28,paddingTop:5}}>
                <div style={{ borderRadius: "4px", height: "25px", width: "25%", backgroundColor: backgroundColor_white }}></div>
            </div>
            <div style={{ paddingBottom: "30px" ,paddingLeft:28}}>
                <div style={{ borderRadius: "4px", height: "50px", width: "75%", backgroundColor: backgroundColor_white }}></div>
            </div>
            <div style={{ paddingBottom: "10px" ,paddingLeft:28}}>
                <div style={{ borderRadius: "4px", height: "30px", width: "100px", backgroundColor: backgroundColor_white }}></div>
            </div>
            <div className="d-flex  col-md-12">
                <div className="col-md-3 mt-2" style={{ paddingRight: "20px" }}>
                    <div style={{ borderRadius: "4px", height: "200px", width: "100%", backgroundColor: backgroundColor_white }}></div>
                    <div style={{ borderRadius: "4px", height: "200px", width: "100%", backgroundColor: backgroundColor_white ,marginTop:40}}></div>
                </div>
                <div className="col-md-9 mt-2 mb-2" style={{ paddingRight: "20px" }}>
                    <div style={{ borderRadius: "4px", height: "60px", width: "100%", backgroundColor: backgroundColor_white }}></div>
                    <div style={{ borderRadius: "4px", height: "60px", width: "100%", backgroundColor: backgroundColor_white ,marginTop:20}}></div>
                    <div style={{ borderRadius: "4px", height: "60px", width: "100%", backgroundColor: backgroundColor_white ,marginTop:20}}></div>
                    <div style={{ borderRadius: "4px", height: "360px", width: "100%", backgroundColor: backgroundColor_white ,marginTop:20}}></div>
                </div>
            </div>
        </div>
    );
}

function skeltonScreenForRegisterCustomize() {
    return (
        <div style={{ width: "100%", margin: "auto", paddingTop: "40px", paddingLeft: "20px", position: "relative" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_gray"></div>
            <div className="row mt-3">
                <div className="col-md-8">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "25px", width: "25%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "30px" }}>
                        <div style={{ borderRadius: "4px", height: "50px", width: "75%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "25px", width: "25%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "30px" }}>
                        <div style={{ borderRadius: "4px", height: "50px", width: "75%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "20px" }}>
                        <div style={{ borderRadius: "4px", height: "100px",backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "20px" }}>
                        <div style={{ borderRadius: "4px", height: "100px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "385px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function skeltonScreenForRegisterCustomerInfo() {
    return (
        <div style={{ width: "100%", margin: "auto", paddingTop: "40px", paddingLeft: "20px", position: "relative" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_gray"></div>
            <div className="row mt-3">
                <div className="col-md-8">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "25px", width: "25%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "30px" }}>
                        <div style={{ borderRadius: "4px", height: "50px", width: "75%", backgroundColor: backgroundColor_white }}></div>
                    </div>

                    <div style={{ paddingBottom: "20px" }}>
                        <div style={{ borderRadius: "4px", height: "200px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "20px" }}>
                        <div style={{ borderRadius: "4px", height: "200px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "385px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function skeltonScreenForRegisterBillingInfo() {
    return (
        <div style={{ width: "100%", margin: "auto", paddingTop: "40px", paddingLeft: "20px", position: "relative" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_gray"></div>
            <div className="row mt-3">
                <div className="col-md-8">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "25px", width: "25%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "30px" }}>
                        <div style={{ borderRadius: "4px", height: "50px", width: "75%", backgroundColor: backgroundColor_white }}></div>
                    </div>

                    <div style={{ paddingBottom: "20px" }}>
                        <div style={{ borderRadius: "4px", height: "200px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "20px" }}>
                        <div style={{ borderRadius: "4px", height: "200px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "385px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function skeltonScreenForRegisterInstallation() {
    return (
        <div style={{ width: "100%", margin: "auto", paddingTop: "40px", paddingLeft: "20px", position: "relative" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_gray"></div>
            <div className="row mt-3">
                <div className="col-md-8">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "25px", width: "25%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "30px" }}>
                        <div style={{ borderRadius: "4px", height: "50px", width: "75%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "20px", width: "45%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "60px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "20px", width: "45%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "60px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "385px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function skeltonScreenForRegisterConfirmation() {
    return (
        <div style={{ width: "100%", margin: "auto", paddingTop: "40px", paddingLeft: "20px", position: "relative" }} className="animated fadeIn">
            <div className="skeltonScreenAnimatedOverlay_gray"></div>
            <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "25px", width: "25%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "30px" }}>
                        <div style={{ borderRadius: "4px", height: "50px", width: "75%", backgroundColor: backgroundColor_white }}></div>
            </div>
            <div className="row mt-3">
                <div className="col-md-6">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "25px", width: "25%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "20px" }}>
                        <div style={{ borderRadius: "4px", height: "300px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                </div>
                <div className="col-md-6">
                    <div style={{ paddingBottom: "10px" }}>
                        <div style={{ borderRadius: "4px", height: "25px", width: "25%", backgroundColor: backgroundColor_white }}></div>
                    </div>
                    <div style={{ paddingBottom: "20px" }}>
                        <div style={{ borderRadius: "4px", height: "300px", backgroundColor: backgroundColor_white }}></div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default {
    skeltonScreenForMyAccountOverview,
    skeltonScreenForMyAccountSub,
    skeltonScreenForBillingAndPayments,
    skeltonScreenForManagePlan,
    skeltonScreenForSettings,
    skeltonScreenForServiceCenter,
    skeltonScreenForRegisterServices,
    skeltonScreenForRegisterCustomize,
    skeltonScreenForRegisterCustomerInfo,
    skeltonScreenForRegisterInstallation,
    skeltonScreenForRegisterConfirmation,
    skeltonScreenForRegisterBillingInfo,
    skeltonScreenForMyAccountAddServiceAddress,
    skeltonScreenForMyAccountAddServiceServices
}